/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthSelectOrganisationRequest, AuthSelectOrganisationResponse } from '../types/AuthSelectOrganisation'

/**
 * POST /auth/select-organisation
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::selectOrganisation
 */
export async function authSelectOrganisation(
	data: AuthSelectOrganisationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthSelectOrganisationResponse>> {
	return axiosInstance.post('/auth/select-organisation', data, config)
}
